import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getRoleTranslationKey } from "~utilities/getRoleTranslationKey";

export const officialRolesDataReturnType = {
  SELECT_OPTIONS: "Select Options",
  FILTER_OPTIONS: "Filter Options",
  RAW: "Raw",
};

export const useOfficialRolesData = (officialRoles, formatMessage, returnType = officialRolesDataReturnType.RAW) => {
  const [officialRolesData, setOfficialRolesData] = useState([]);
  const { sport } = useParams();
  useEffect(() => {
    const data = [];

    if (officialRoles?.length) {
      officialRoles.forEach((role) => {
        const value = role;
        const translation = formatMessage({
          id: `roles.${getRoleTranslationKey(role, sport)}`,
        });

        if (returnType === officialRolesDataReturnType.SELECT_OPTIONS) {
          data.push({
            value: value,
            label: translation,
          });
        } else if (returnType === officialRolesDataReturnType.FILTER_OPTIONS) {
          data.push({
            value: value,
            text: translation,
          });
        } else if (returnType === officialRolesDataReturnType.RAW) {
          data.push(value);
        }
      });

      setOfficialRolesData(data);
    }
  }, [formatMessage, officialRoles, returnType, sport]);

  return officialRolesData;
};

export default useOfficialRolesData;
